import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'cvlib';
//---------------------------------------------------------------------------------------
import './style.scss';
import { hideDeleteConfirmationModal } from 'containers/CarouselsDisplay/redux/actions/deleteConfirmationModal.actions';
import { useDisableScrollInModal } from 'hooks/useDisableScrollInModal';
import { z_index } from 'const/zIndex';

const DeleteConfirmationModal = () => {
  const dispatch = useDispatch();
  const {
    show,
    contentName,
    deleteCallback,
    cancelCollback,
    contentType,
  } = useSelector(state => state.cvCMS.deleteConfirmationModal);

  useDisableScrollInModal(show);

  const {
    contentToDelete_modal_titleFavoritedLive_label,
    contentToDelete_modal_titleFavorite_label,
    contentToDelete_modal_titleLastSeen_label,
    contentToDelete_modal_titleLivechannels_label,
    contentToDelete_modal_descriptionBegin_label,
    contentToDelete_modal_descriptionEnd_label,
    contentToDelete_modal_option_button_cancel,
    contentToDelete_modal_option_button_deleteRecord,
    contentToDelete_modal_titleRecordingPresentEvent_label,
    contentToDelete_modal_titleRecordingPresentSeason_label,
    contentToDelete_modal_titleRecordingPresentEpisode_label,
  } = useSelector(state => state.translations);

  let titleLabel = '';
  switch (contentType) {
    case 'FavoritedLive':
      titleLabel = contentToDelete_modal_titleFavoritedLive_label;
      break;
    case 'favorited':
      titleLabel = contentToDelete_modal_titleFavorite_label;
      break;
    case 'seen':
      titleLabel = contentToDelete_modal_titleLastSeen_label;
      break;
    case 'admincms_userchannels':
      titleLabel = contentToDelete_modal_titleLivechannels_label;
      break;
    case 'recording_event':
      titleLabel = contentToDelete_modal_titleRecordingPresentEvent_label;
      break;
    case 'recording_serie':
      titleLabel = contentToDelete_modal_titleRecordingPresentSeason_label;
      break;
    case 'episode':
      titleLabel = contentToDelete_modal_titleRecordingPresentEpisode_label;
      break;

    default:
      break;
  }

  const handleOptionClick = option => {
    switch (option) {
      case 'delete':
        deleteCallback();
        break;
      case 'cancel':
        cancelCollback();
        break;
      default:
        break;
    }
    dispatch(hideDeleteConfirmationModal);
  };

  return (
    <Modal
      isOpen={show}
      classNames={['delete-confirmation-modal']}
      zIndex={z_index?.modalConfirmationDeleteCards}
      mainStyles={['delete-confirmation-modal__background']}
    >
      <p className="delete-confirmation-modal__title">{titleLabel}</p>

      <p className="delete-confirmation-modal__description">
        {`${contentToDelete_modal_descriptionBegin_label} ${contentName}${contentToDelete_modal_descriptionEnd_label}`}
      </p>

      <button
        type="button"
        className="delete-confirmation-modal__delete"
        onClick={() => handleOptionClick('delete')}
      >
        {`${contentToDelete_modal_option_button_deleteRecord}`}
      </button>
      <button
        type="button"
        className="delete-confirmation-modal__cancel"
        onClick={() => handleOptionClick('cancel')}
      >
        {contentToDelete_modal_option_button_cancel}
      </button>
    </Modal>
  );
};



export default DeleteConfirmationModal;
